<script>

    import File from "./File.svelte";
    import MenuLink from "./MenuLink.svelte";
    import {createEventDispatcher} from "svelte";
    import { t } from "../../../i18n";

    export let menus = [
        //{id: 'all', title:'All Files', extra:3},
    ];

    $: hasFolders = menus && menus.length;

    let dispatch = createEventDispatcher();

    let section;
    let changeFolder = dest => dispatch('changeFolder', dest);

</script>


<div class="sidebar-left" bind:this={section}>
    <div class="sidebar">
        <div class="app-file-sidebar sidebar-content d-flex" style="width:auto !important; {hasFolders?'':'border:none'}">

            <div class="app-file-sidebar-left">

                <span class="app-file-sidebar-close"><i class="bx bx-x"></i></span>

                <!--
                <div class="form-group add-new-file text-center">
                    <label for="getFile" class="btn btn-primary btn-block glow my-2 add-file-btn text-capitalize"><i class="bx bx-plus"></i>Add File</label>
                    <input type="file" class="d-none" id="getFile">
                </div>
                -->

                <div class="app-file-sidebar-content" style="width:260px; {hasFolders?'':'display:none'}">
                    <label class="app-file-label">{$t('files.folders')}</label>
                    <div class="list-group list-group-messages my-50">
                        {#each menus as menu, index}
                            <MenuLink on:click={()=>changeFolder(menu.id)} title={menu.title} active={index==0} extra={menu.extra||''} icon="name: morph-folder.svg; size: 24px; style: lines; strokeColor:#5A8DEE; eventOn:grandparent; duration:0.85;"></MenuLink>
                        {/each}
                    </div>
                </div>

            </div>
        </div>

        <File></File>

    </div>
</div>